<div class="application-conversation section no-padding">
  <div class="section-header">
    <div class="inline">
      <h5>
        {{ 'pages.serviceProcessing.applicationConversation.title' | translate }}
      </h5>
      <app-tooltip text="applicationConversation" />
    </div>
    <div class="actions">
      @if (shouldRenderRequestAdditionalInfoButton) {
        <button class="primary" (click)="sendEmailMessage()">
          {{ 'pages.serviceProcessing.sendEmailMessage' | translate }}
        </button>
        <button class="primary" (click)="requestAdditionalInfo()">
          {{ 'pages.serviceProcessing.sendPortalMessage' | translate }}
        </button>
      }
      <button class="secondary" (click)="addClientNote()">
        {{ 'pages.serviceProcessing.addClientNote' | translate }}
      </button>
    </div>
  </div>
  <div class="content">
    <div class="table-header">
      <div class="inline">
        <p>
          {{ 'pages.serviceProcessing.applicationConversation.archive' | translate }}
        </p>
        <app-tooltip [marginBottom]="false" text="applicationConversationLna" />
      </div>
      <div class="inline">
        <p>
          {{ 'pages.serviceProcessing.applicationConversation.client' | translate }}
        </p>
        <app-tooltip [marginBottom]="false" text="applicationConversationClient" />
      </div>
    </div>
    <div class="messages-wrapper">
      @for (message of conversationList; track message.id) {
        <div class="message-row">
          <div class="message-row-wrapper" [ngClass]="[message.type]">
            @if (message.type !== 'Rescheduled') {
              <div class="message backoffice-message">
                <div class="message-top-row">
                  <div class="message-header">
                    <p class="message-title">
                      {{ message.createdByUser?.fullName }}@if (message.type === 'SentByEmail') {/{{ 'pages.viewInfoRequest.conversation.emailToClient' | translate }} <i class="bi bi-envelope"></i>}
                    </p>
                    <p class="message-date">
                      {{ formatDatetime(message.createdOn, false) }}
                    </p>
                  </div>
                  @if (message.type !== 'RequestAdditionalInformation' && message.type !== 'SentByEmail') {
                    <button class="link edit-btn" (click)="editMessage(message)">
                      <img src="assets/images/edit-icon.svg" alt="edit icon" />
                      {{ 'components.table.edit' | translate }}
                    </button>
                  }
                </div>
                @if (message.type === 'SentByEmail') {
                  @if (message.recipient) {
                    <p class="message-email-info">{{ message.recipient }}</p>
                  }
                  @if (message.emailSubject) {
                    <p class="message-email-info message-email-subject">{{ message.emailSubject }}</p>
                  }
                }
                <p class="message-text">{{ message.backofficeText }}</p>
                @if (message.backofficeFiles && message.backofficeFiles.length) {
                  <div class="file-wrapper">
                    <app-file-upload
                      [isEditMode]="false"
                      [existingFiles]="message.backofficeFiles || []"
                      [type]="communicationFileTypeBackoffice"
                      [associatedEntityId]="message.id"
                      [isSubmitting]="false" />
                  </div>
                }
              </div>
            }
            @if (message.frontofficeText) {
              <div class="reply message">
                <div class="message-top-row">
                  <div class="message-header">
                    <p class="message-title">
                      {{ informationRequest.client?.name }}
                      {{ informationRequest.client?.surname }}
                    </p>
                    <p class="message-date">
                      {{ formatDatetime(message.type === 'Rescheduled' ? message.createdOn : message.frontofficeTextCreatedOn, false) }}
                    </p>
                    @if (!message.isReadByBackoffice) {
                      <div class="message-unread-indicator"></div>
                    }
                  </div>
                </div>
                <p class="message-text" [innerHTML]="message.frontofficeText"></p>
                @if (message.frontofficeFiles.length) {
                  <div class="file-wrapper">
                    <app-file-upload
                      [isEditMode]="false"
                      [existingFiles]="message.frontofficeFiles || []"
                      [type]="communicationFileTypeFrontoffice"
                      [associatedEntityId]="message.id"
                      [isSubmitting]="false" />
                  </div>
                }

                @if (!message.isReadByBackoffice) {
                  <button class="button-link mark-as-read" (click)="markAsRead(message.id)">
                    <img src="assets/images/double-check.svg" alt="view" />
                    {{ 'components.table.markAsRead' | translate }}
                  </button>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</div>
<app-ir-log-info-modal
  [isOpen]="isAddClientNoteModalOpen"
  [informationRequest]="informationRequest"
  (cancel)="isAddClientNoteModalOpen = false"
  (requestRefreshed)="onRequestRefreshed($event)"
  (update)="onMessageSaved($event)" />
<app-ir-log-info-modal
  [isOpen]="isEditClientNoteModalOpen"
  [informationRequest]="informationRequest"
  [note]="this.editNote"
  (cancel)="isEditClientNoteModalOpen = false"
  (requestRefreshed)="onRequestRefreshed($event)"
  (update)="onMessageSaved($event)" />
<app-ir-request-info-modal
  [isOpen]="isRequestAdditionalInfoModalOpen"
  [informationRequest]="informationRequest"
  (cancel)="isRequestAdditionalInfoModalOpen = false"
  (update)="onMessageSaved($event)" />
<app-ir-send-email-modal
  [isOpen]="isSendEmailModalOpen"
  [informationRequest]="informationRequest"
  (cancel)="isSendEmailModalOpen = false"
  (update)="onMessageSaved($event)" />
